import {SisType} from "generated/JavaTO"

export const castToSisTypePrimitive = (val: any, type: SisType) => {
	switch (type) {
		case SisType.String:
		case SisType.VChar:
		case SisType.Key:
			val += '';
			break;
		case SisType.Int:
		case SisType.Number:
		case SisType.Date:
		case SisType.Time:
		case SisType.Duration:
		case SisType.Duration2:
			val = parseInt(val);
			break;
		case SisType.Float:
			val = parseFloat(val);
			break;
		default:
			break;
	}
	return val;
};